import React from "react";

import { t } from "i18next";

import { TDaySummary } from "@/utils/UTasks";

/**
 * A day of the compact calendar: one full-width bar split by project,
 * the task count small and grey under it - the bar keeps it apart from
 * the day's number above.
 */
export const CalendarDayBar: React.FC<TDaySummary> = ({ count, segments }) => {
	if (!count) return null;
	return (
		<div
			className="flex w-full flex-col items-center gap-0.5"
			data-testid="calendar-day-bar"
		>
			<div className="flex h-1.5 w-full gap-px overflow-hidden rounded-full">
				{segments.map(({ color, count: share }) => (
					<span
						key={color}
						className="h-full"
						style={{ flexGrow: share, backgroundColor: color }}
					/>
				))}
			</div>
			<span
				className="text-[10px] leading-none text-neutral-400"
				aria-hidden="true"
			>
				{count}
			</span>
			<span className="sr-only">{t("tasks.count", { count })}</span>
		</div>
	);
};
